import watchCreateDefaultHoursSaga from '@/store/sagas/setting/createDefaultHorusSaga';

import watchFetchPlaceLocalizationSaga from '../setting/fetchPlaceLocalizationSaga';
import watchAddSpecialHourSaga from './addSpecialHourSaga';
import companySettingSagas from './company';
import watchDeleteSpecialHourSaga from './deleteSpecialHourSaga';
import watchFetchFacebookPageSaga from './facebook/fetchFacebookPageSaga';
import watchFetchFacebookPagesSaga from './facebook/fetchFacebookPagesSaga';
import watchSaveFacebookPageSaga from './facebook/saveFacebookPageSaga';
import watchFetchContactSaga from './fetchContactSaga';
import watchFetchHoursSaga from './fetchHoursSaga';
import watchFetchProfileSaga from './fetchProfileSaga';
import watchFetchReservationSettingsSaga from './fetchReservationSettingSaga';
import watchModifySpecialHourSaga from './modifySpecialHourSaga';
import watchSaveContactSaga from './saveContactSaga';
import watchSaveProfileSaga from './saveProfileSaga';
import watchSaveRegularHoursSaga from './saveRegularHoursSaga';
import watchSaveReservationSettingsSaga from './saveReservationSettingSaga';

const settingSagas = [
  watchAddSpecialHourSaga(),
  watchModifySpecialHourSaga(),
  watchDeleteSpecialHourSaga(),
  watchFetchContactSaga(),
  watchFetchHoursSaga(),
  watchFetchProfileSaga(),
  watchFetchReservationSettingsSaga(),
  watchSaveContactSaga(),
  watchCreateDefaultHoursSaga(),
  watchSaveRegularHoursSaga(),
  watchSaveProfileSaga(),
  watchSaveReservationSettingsSaga(),
  watchFetchPlaceLocalizationSaga(),
  watchFetchFacebookPagesSaga(),
  watchFetchFacebookPageSaga(),
  watchSaveFacebookPageSaga(),
  ...companySettingSagas,
];
export default settingSagas;
